const WebPageSchema = ({
  name,
  url,
  description,
  type = "WebPage"
}) => {
  return {
    "@context": "https://schema.org",
    "@type": type,
    "@id": `${url}#webpage`,

    "url": url,

    "name": name,

    "description": description,

    "isPartOf": {
      "@id": "https://gurukrupawood.com/#website"
    },

    "about": {
      "@id": "https://gurukrupawood.com/#organization"
    }
  };
};

export default WebPageSchema;